/**
 * The "Practice" menu. See lib/navigation/nav-manifest.js for the entry shape
 * and the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const PRACTICE_ITEMS = [
  {
    href: "/simulator",
    label: "Practice Scenarios",
    shortcut: "S",
    iconName: "LiaTheaterMasksSolid",
    requires: "workspace",
    // The modules the Practice Scenarios page launches, listed under it. Each
    // shows when the studio runs it; the studio's own name for it replaces
    // the label (`moduleLabels: "practice"`).
    //
    // Conversation Analysis and Deal Clinic work on real calls and deals, not
    // practice, so they are listed under Execution only (Michael, 20 October).
    subItems: [
      {
        href: "/simulator/discovery",
        label: "Discovery",
        iconName: "CiMap",
        requires: "practiceModule",
      },
      {
        href: "/simulator/pitch",
        label: "Messaging / Pitch",
        iconName: "HiOutlinePresentationChartBar",
        requires: "practiceModule",
      },
      {
        href: "/simulator/objections",
        label: "Objections",
        iconName: "HiNoSymbol",
        requires: "practiceModule",
      },
      {
        href: "/simulator/cold-call",
        label: "Outbound & Inbound",
        iconName: "IoCallOutline",
        requires: "practiceModule",
      },
      {
        href: "/simulator/plays",
        label: "Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "practiceModule",
      },
      {
        href: "/simulator/management",
        label: "Management Practice",
        iconName: "HiOutlineUserGroup",
        requires: ["practiceModule", "supervisorOrAbove"],
      },
      {
        href: "/simulator/on-the-fly",
        label: "On-the-fly Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "practiceModule",
      },
      {
        href: "/stories",
        label: "Stories",
        description: "Create and manage your sales stories",
        iconName: "IoBookOutline",
        requires: "stories",
      },
    ],
  },
  {
    // Practice scenarios assigned to you live with the rest of practice; tests
    // and learning paths assigned to you are in Learn, and My Training lists
    // all three.
    href: "/dashboard/assignments",
    label: "Assignments",
    description:
      "Practice scenarios assigned to you. Tests and learning paths are tracked separately under Tests and Learning Paths.",
    iconName: "ClipboardList",
    requires: "workspace",
  },
  {
    href: "/simulator/personas",
    label: "Personas",
    heading: "Personas Playbook",
    description:
      "Pick a persona, then launch the simulator modules tailored to them.",
    iconName: "IoPersonOutline",
    requires: "workspace",
  },
  {
    href: "/simulator/seller-personas",
    label: "Other Personas",
    description:
      "Browse and interact with AI-powered personas for management practice scenarios.",
    iconName: "IoPeopleOutline",
    requires: ["workspace", "management", "supervisorOrAbove"],
  },
];
